import React from 'react';
import StaffLayout from '../../layouts/StaffLayout';
import CalendarCore from '../../components/CalendarCore';

export default function StaffCalendarPage() {
  return (
    <StaffLayout>
      <CalendarCore />
    </StaffLayout>
  );
}
